export enum TextAlign {
  left = 1,
  right,
  center,
  justify,
  start,
  end,
}
